import React from 'react';
import PropTypes from 'prop-types';
import { Col, Divider, Row, Space } from 'antd';
import handleDates from 'utils/timeDifference';
import './TransactionSummaryCard.scss';

import {
  TotalTransactionCountIcon,
  TotalTransactionAmountIcon,
  TotalPartnerCommissionEarnedIcon,
  TotalPartnerCommissionExpectedIcon
} from 'utils/icons';
import currencyFormat from 'utils/currencyFormat';

const transactionCardLabel = [
  'Total Transaction Count',
  'Total Transactions Amount',
  'Total Partner Commission Expected',
  'Total Partner Commission Earned'
];

function TransactionSummaryCard({ transactionSummary }) {
  return (
    <div className="transaction-summary-card">
      <Row className="card-main-container" justify="space-around">
        <Col className="gutter-row">
          <Row className="row-config">
            <Col className="col-config">
              <Space direction="vertical">
                <Space>
                  <TotalTransactionCountIcon style={{ fontSize: '25px' }} />
                  <span className="span-font-size">{transactionCardLabel[0]}</span>
                </Space>
                <Space align="end" className="space-font-size">
                  <span>{transactionSummary.total_transaction_count}</span>
                </Space>
              </Space>
            </Col>
          </Row>
        </Col>
        <Divider type="vertical" className="vertical-divider" />
        <Col className="gutter-row">
          <Row className="row-config">
            <Col className="col-config">
              <Space direction="vertical">
                <Space>
                  <TotalTransactionAmountIcon style={{ fontSize: '25px' }} />
                  <span className="span-font-size">{transactionCardLabel[1]}</span>
                </Space>
                <Space align="end" className="space-font-size">
                  {currencyFormat(transactionSummary.total_transaction_amount, true, true)}
                </Space>
              </Space>
            </Col>
          </Row>
        </Col>
        <Divider type="vertical" className="vertical-divider" />
        <Col className="gutter-row">
          <Row className="row-config">
            <Col className="col-config">
              <Space direction="vertical">
                <Space>
                  <TotalPartnerCommissionEarnedIcon style={{ fontSize: '25px' }} />
                  <span className="span-font-size">{transactionCardLabel[2]}</span>
                </Space>
                <Space align="end" className="space-font-size">
                  <span>
                    {currencyFormat(
                      transactionSummary.total_commission_amount_expected,
                      true,
                      true
                    )}
                  </span>
                </Space>
              </Space>
            </Col>
          </Row>
        </Col>
        <Divider type="vertical" className="vertical-divider" />
        <Col className="gutter-row">
          <Row className="row-config">
            <Col className="col-config">
              <Space direction="vertical">
                <Space>
                  <TotalPartnerCommissionExpectedIcon style={{ fontSize: '25px' }} />
                  <span className="span-font-size">{transactionCardLabel[3]}</span>
                </Space>
                <Space align="end" className="space-font-size">
                  <span>
                    {currencyFormat(transactionSummary.total_commission_amount_earned, true, true)}
                  </span>
                </Space>
              </Space>
            </Col>
          </Row>
        </Col>
        <Col
          align="start"
          style={{ position: 'absolute', right: 0, top: '-2px', paddingBottom: '20px' }}
        >
          <span
            style={{
              padding: '2px 5px',
              fontSize: '12px',
              borderRadius: '10px',
              backgroundColor: '#DDF5DC',
              color: '#0A9305'
            }}
          >
            Last updated {handleDates(transactionSummary?.document_updated_at)}
          </span>
        </Col>
      </Row>
    </div>
  );
}

TransactionSummaryCard.propTypes = {
  transactionSummary: PropTypes.instanceOf(Object).isRequired
};

export default TransactionSummaryCard;
